// Une session de diagnostic ne remplace jamais la connexion des autres onglets.
export const IMPERSONATION_META_KEY = "aon_impersonation";
export const IMPERSONATION_AUTH_KEY = "noa-impersonation-auth";
export const ADMIN_SESSION_KEY = "aon_impersonation_admin_session";

export interface ImpersonatedUser {
  id: string;
  email: string;
  displayName: string;
  returnAt?: number;
  isolated?: boolean;
  debug?: boolean;
  storageKey?: string;
}

export function readImpersonation(): ImpersonatedUser | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(IMPERSONATION_META_KEY) ?? "null");
    return value && typeof value.id === "string" ? value : null;
  } catch {
    return null;
  }
}

export function clearImpersonation(): void {
  const key = readImpersonation()?.storageKey;
  if (key?.startsWith(`${IMPERSONATION_AUTH_KEY}-`)) sessionStorage.removeItem(key);
  sessionStorage.removeItem(IMPERSONATION_META_KEY);
  sessionStorage.removeItem(IMPERSONATION_AUTH_KEY);
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}
